import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EMPTY, catchError, filter, map, of, share, take } from 'rxjs';
import * as i0 from "@angular/core";
const IP_ADDRESS_SERVICE_URL = 'https://api.ipify.org?format=json';
let ipAddressObservable;
let ipAddressValue;
export class IpAddressService {
    constructor(injector) {
        setTimeout(() => {
            this.http = injector.get(HttpClient);
            const existingRequest = ipAddressObservable;
            if (!existingRequest) {
                ipAddressObservable = this.http.get(IP_ADDRESS_SERVICE_URL).pipe(share(), take(1), map(data => data.ip), catchError(() => 
                // There was an error retrieving the IP address from the external service
                // probably because of an ad-blocker
                EMPTY));
                ipAddressObservable
                    .pipe(filter(ipAddress => !!ipAddress))
                    .subscribe(ipAddress => (ipAddressValue = ipAddress));
            }
        });
    }
    get ipAddressAsync() {
        return ipAddressValue ? of(ipAddressValue) : ipAddressObservable;
    }
    get ipAddress() {
        return ipAddressValue;
    }
    static { this.ɵfac = function IpAddressService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IpAddressService)(i0.ɵɵinject(i0.Injector)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IpAddressService, factory: IpAddressService.ɵfac }); }
}
//# sourceMappingURL=ip-address.service.js.map